import moment from "moment";
import { resumirParos, formatoMinutos, nombreCompleto } from "../Pages/Panel/PresupuestosPU/TiemposMuertosPU/reporteTiemposMuertos.utils";

const TINTA = "#1A3A4A";
const GRIS = "#8C8C8C";
const PETROLEO = "#006B7A";
const CIAN = "#00BFD6";
const ANCHO = 752;

const celda = (valor, extra = {}) => ({ text: valor === null || valor === undefined ? "" : String(valor), style: "celda", ...extra });
const layout = { hLineColor: () => "#adaaaa", vLineColor: () => "#adaaaa", fillColor: (fila) => (fila === 0 ? "#C5E3F6" : null) };

const reporteTiemposMuertosPdf = ({ paros, empresa = {}, descripcion, usuarioNombre }) => {
  const resumen = resumirParos(paros);
  const detalle = [
    ["Fecha", "Hora de paro", "Hora de arranque", "Tiempo muerto", "Código", "Origen", "Motivo", "Registró", "Observaciones"].map((t) => ({ text: t, style: "encabezado" })),
    ...paros.map((p) => [
      celda(moment(p.fechaParo).format("DD/MM/YYYY")),
      celda(moment(p.fechaParo).format("HH:mm")),
      celda(p.fechaArranque ? moment(p.fechaArranque).format(moment(p.fechaArranque).isSame(p.fechaParo, "day") ? "HH:mm" : "DD/MM HH:mm") : "Abierto"),
      celda(formatoMinutos(p.minutos), { bold: true }),
      celda(p.codigo),
      celda(p.origen),
      celda(p.motivo, { alignment: "left" }),
      celda(nombreCompleto(p.usuarioId), { alignment: "left" }),
      celda(p.observaciones || "", { alignment: "left" }),
    ]),
    [
      { text: "TIEMPO MUERTO TOTAL (HORA:MINUTO)", colSpan: 3, style: "celda", bold: true, alignment: "right" },
      {},
      {},
      celda(formatoMinutos(resumen.totalMinutos), { bold: true }),
      { text: "", colSpan: 5 },
      {},
      {},
      {},
      {},
    ],
  ];
  const tablaResumen = (filas, conCodigo) => [
    [...(conCodigo ? ["Código"] : []), "Origen", ...(conCodigo ? ["Motivo"] : []), "Paros", "Tiempo muerto", "%", "% acum."].map((t) => ({ text: t, style: "encabezado" })),
    ...filas.map((f) => [
      ...(conCodigo ? [celda(f.codigo)] : []),
      celda(f.origen),
      ...(conCodigo ? [celda(f.motivo, { alignment: "left" })] : []),
      celda(f.paros),
      celda(formatoMinutos(f.minutos)),
      celda(`${f.porcentaje}%`),
      celda(`${f.porcentajeAcumulado}%`),
    ]),
  ];

  return {
    pageOrientation: "landscape",
    pageSize: "LETTER",
    pageMargins: [20, 20, 20, 28],
    footer: (actual, total) => ({
      columns: [
        { text: `Imprimió: ${usuarioNombre || "—"}`, fontSize: 7, color: GRIS, margin: [20, 6, 0, 0] },
        { text: `${actual} / ${total}`, alignment: "right", fontSize: 7, color: GRIS, margin: [0, 6, 20, 0] },
      ],
    }),
    content: [
      {
        columns: [
          empresa.logo?.base64Completa ? { image: "logo", fit: [64, 64], width: 80 } : { text: "", width: 80 },
          {
            width: "*",
            stack: [
              { text: empresa.nombre || "-", fontSize: 16, bold: true, color: TINTA, alignment: "center" },
              { text: "REPORTE DE TIEMPOS MUERTOS", fontSize: 13, bold: true, color: PETROLEO, alignment: "center", margin: [0, 4, 0, 0] },
              { text: descripcion || "", fontSize: 9, color: GRIS, alignment: "center" },
            ],
          },
          {
            width: 120,
            stack: [
              { text: "MPP-FT-49", fontSize: 10, bold: true, alignment: "right" },
              { text: moment().format("DD/MM/YYYY HH:mm"), fontSize: 8, color: GRIS, alignment: "right" },
            ],
          },
        ],
      },
      { canvas: [{ type: "line", x1: 0, y1: 4, x2: ANCHO, y2: 4, lineWidth: 2, lineColor: CIAN }], margin: [0, 4, 0, 8] },
      paros.length
        ? { table: { headerRows: 1, widths: [48, 40, 52, 44, 32, 70, "*", 100, 110], body: detalle }, layout }
        : { text: "No hay paros en este periodo.", color: GRIS },
      ...(paros.length
        ? [
            {
              margin: [0, 14, 0, 0],
              columns: [
                { width: 260, stack: [{ text: "Por origen", style: "titulo" }, { table: { headerRows: 1, widths: ["*", 30, 50, 34, 40], body: tablaResumen(resumen.porOrigen, false) }, layout }] },
                { width: 16, text: "" },
                { width: "*", stack: [{ text: "Por código", style: "titulo" }, { table: { headerRows: 1, widths: [34, 64, "*", 30, 50, 34, 40], body: tablaResumen(resumen.porCodigo, true) }, layout }] },
              ],
            },
          ]
        : []),
    ],
    images: empresa.logo?.base64Completa ? { logo: empresa.logo.base64Completa } : {},
    defaultStyle: { font: "Roboto", fontSize: 7.5 },
    styles: {
      encabezado: { fontSize: 7, bold: true, alignment: "center" },
      celda: { fontSize: 7.5, alignment: "center" },
      titulo: { fontSize: 10, bold: true, color: PETROLEO, margin: [0, 0, 0, 4] },
    },
  };
};

export default reporteTiemposMuertosPdf;
